import './button.css'
import { memo } from 'react'
import classNames from 'classnames'

// <BigButton backgroundColor={'#E3730C'} onClick={() => alert('test')}>テスト</BigButton>

type Props = {
  onClick: () => void
  children: string
  className?: string
  disabled?: boolean
}

export const BigButton = memo(
  ({ onClick, children, className, ...rest }: Props) => {
    return (
      <button
        className={classNames(className, 'big-button')}
        onClick={onClick}
        {...rest}
      >
        {children}
      </button>
    )
  },
)
